import { OperationVariables, TypedDocumentNode } from '@apollo/client'
import { Box } from '@factorialco/deprecated-design-system'

import { DragItem } from 'modules/project_management/components/Kanban/utils'

import KanbanColumn, { IColumnAction, KanbanColumnData, KanbanColumnType } from './Column'

interface KanbanProps<TQuery, TVariables, TItem> {
  actions?: React.ReactNode
  columnAction?: IColumnAction
  columns: KanbanColumnType<TVariables>[]
  dataSource: (data: NonNullable<TQuery>) => {
    edges: Edge[]
    pageInfo: { hasNextPage: boolean; endCursor: string }
  }
  document: TypedDocumentNode<TQuery, TVariables>
  handleDrop: (
    originalItem: DragItem<TVariables, TItem>,
    dropColumn: TVariables,
    beforePosition?: string | null,
    afterPosition?: string | null
  ) => void
  parseData: (data: TQuery | undefined) => KanbanColumnData<TItem>
}

interface Edge {
  cursor: string
  node: unknown
}

const Kanban = <TQuery, TVariables extends OperationVariables, TItem>({
  actions,
  columnAction,
  columns,
  dataSource,
  document,
  handleDrop,
  parseData,
}: KanbanProps<TQuery, TVariables, TItem>) => {
  const renderColumn = (column: KanbanColumnType<TVariables>) => {
    return (
      <KanbanColumn
        key={column.title}
        columnAction={columnAction}
        column={column}
        document={document}
        handleDrop={handleDrop}
        parseData={parseData}
        dataSource={dataSource}
      />
    )
  }

  return (
    <>
      {actions && (
        <Box
          flexDirection="row"
          gap="s8"
          paddingBottom="s16"
          flexNoShrink
          justifyContent="flexEnd"
          alignItems="center"
        >
          {actions}
        </Box>
      )}
      <Box flexDirection="row" gap="s8" overflowX="auto" paddingBottom="s24">
        {columns.map(renderColumn)}
      </Box>
    </>
  )
}

export default Kanban
